<template>
  <v-container
      fluid
  >
    <v-card class="pa-5" tile>
      <v-form
        autocomplete="off"
        @submit="function(e){saveItem();e.preventDefault()}"
      >

        <v-row class="mt-n5">
            <v-col sm="2" class="px-0">
                {{ $t('Main status') }}
            </v-col>
            <v-col sm="6" class="px-0">
                <v-select
                    v-model="search.main_status_ids"
                    :error-messages="errors.main_status_ids"
                    :items="main_statuses"
                    filled
                    chips
                    dense
                    multiple
                    clearable
                    tabindex="10"
                />
            </v-col>
        </v-row>

        <v-row class="mt-n5">
            <v-col sm="2" class="px-0">
                {{ $t('Appointment location') }}
            </v-col>
            <v-col sm="6" class="px-0">
                <v-select
                    v-model="search.appointment_location_ids"
                    :error-messages="errors.appointment_location_ids"
                    :items="appointment_locations"
                    filled
                    chips
                    dense
                    multiple
                    clearable
                    tabindex="20"
                />
            </v-col>
        </v-row>

        <v-row class="mt-n5">
            <v-col sm="2" class="px-0">
                {{ $t('Diagnosis status (type of lip)') }}
            </v-col>
            <v-col sm="6" class="px-0">
                <v-select
                    v-model="search.revision_lip_statuses"
                    :error-messages="errors.revision_lip_statuses"
                    :items="revision_lip_status_options"
                    filled
                    chips
                    dense
                    multiple
                    clearable
                    tabindex="30"
                />
            </v-col>
        </v-row>

        <v-row class="mt-n5">
            <v-col sm="2" class="px-0">
                {{ $t('Diagnosis status (type of palate)') }}
            </v-col>
            <v-col sm="6" class="px-0">
                <v-select
                    v-model="search.revision_palate_statuses"
                    :error-messages="errors.revision_palate_statuses"
                    :items="revision_palate_status_options"
                    filled
                    chips
                    dense
                    multiple
                    clearable
                    tabindex="40"
                />
            </v-col>
        </v-row>

        <v-row class="mt-n5">
          <v-col cols="2" sm="2" class="px-0">
            {{ $t('Weight last appointment') }}
          </v-col>
          <v-col cols="3" sm="3" class="px-0">
            {{ $t('From') }}
            <v-text-field
                v-model="search.from_weight"
                :error-messages="errors.from_weight"
                label=""
                autocomplete="off"
            >
              <template v-slot:append>
                  <span class="append-text">kg</span>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="3" sm="3" class="px-0">
            {{ $t('Up to') }}
            <v-text-field
                v-model="search.to_weight"
                :error-messages="errors.to_weight"
                label=""
                autocomplete="off"
            >
              <template v-slot:append>
                <span class="append-text">kg</span>
              </template>
            </v-text-field>
          </v-col>
        </v-row>

        <v-row class="mt-n5">
          <v-col cols="2" sm="2" class="px-0">
            {{ $t('Length last appointment') }}
          </v-col>
          <v-col cols="3" sm="3" class="px-0">
            {{ $t('From') }}
            <v-text-field
                v-model="search.from_length"
                :error-messages="errors.from_length"
                label=""
                autocomplete="off"
            >
              <template v-slot:append>
                <span class="append-text">cm</span>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="3" sm="3" class="px-0">
            {{ $t('Up to') }}
            <v-text-field
                v-model="search.to_length"
                :error-messages="errors.to_length"
                label=""
                autocomplete="off"
            >
              <template v-slot:append>
                <span class="append-text">cm</span>
              </template>
            </v-text-field>
          </v-col>
        </v-row>

        <v-row>
            <v-col cols="2" sm="2" class="px-0">
                {{ $t('Action') }}
            </v-col>
            <v-col cols="2" sm="2" class="px-0">
                <v-btn @click="resetForm">{{ $t('Clear form') }}</v-btn>
                &nbsp;
                <v-btn @click="exportXls">{{ $t('Export XLS') }}</v-btn>
            </v-col>
        </v-row>

      </v-form>

    </v-card>
  </v-container>
</template>

<script>
import ApiService from '@/services/api.service'
// import DatePickerField from '@/components/DatePickerField'
import {fetchMultipleLists} from '@/lib/helpers'

export default {
  components: {
    // DatePickerField,
  },
  data: () => ({
    errors: {},
    search: {},
    main_statuses: [],
    appointment_locations: [],
    revision_lip_status_options: [],
    revision_palate_status_options: [],
  }),
  watch: {
    '$i18n.locale': function () {
        this.fetchTranslatables()
    },
  },
  methods: {
    resetForm() {
      this.search = {
        main_status_ids: null,
        appointment_location_ids: null,
        revision_lip_status_ids: null,
        revision_palate_status_ids: null,
        weight_from: null,
        weight_to: null,
        length_from: null,
        length_to: null,
      }
    },
    getItem() {
      const item = this.search
      return item
    },
    exportXls() {
      this.errors = {}
      this.$store.dispatch('session/showLoader')
     
      ApiService.download(`/exports/surgery/xls`, { filter: this.search }).then(response => {
        this.openFile(response.data, response.filename)
      }).catch(errors => {
        this.errors = errors
        console.log(errors)
      }).finally(() => {
        this.$store.dispatch('session/hideLoader')
      })
    },
    openFile(blob, filename) {
        const data = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = data;
        link.download=filename;
        link.click();
        setTimeout(function(){
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
        }, 100);
    },
    fetchTranslatables() {
        fetchMultipleLists(this, {
            // These must be listed in created() as well
            main_status: 'main_statuses',
        }, '/master-files/get-multiple-lists', 'master_file_type_tags')

        fetchMultipleLists(this, {
            // These must be listed in created() as well
            revision_lip_status_options: 'revision_lip_status_options',
            revision_palate_status_options: 'revision_palate_status_options',
        }, '/surgeries/get-multiple-lists', 'master_file_type_tags')
    },
  },
  created() {
    this.resetForm();
    this.$store.dispatch('session/title', 'Reports - Surgeries')
    fetchMultipleLists(this, {
        // Non-translatable
        appointments_where: 'appointment_locations',

        // Translatable; must be listed in fetchTranslatables() as well
        main_status: 'main_statuses',
    }, '/master-files/get-multiple-lists', 'master_file_type_tags')
    
    fetchMultipleLists(this, {
        // Translatable; must be listed in fetchTranslatables() as well
        revision_lip_status_options: 'revision_lip_status_options',
        revision_palate_status_options: 'revision_palate_status_options',
    }, '/surgeries/get-multiple-lists', 'master_file_type_tags')
  },
}
</script>

<style scoped>

</style>
